import {toURL} from '@homeaway/search-url-parser';

import {
    undef,
    getNoUndefArray,
    getUniqueArray,
    getUrlSearchParamsString,
    getDestinationValuesFilter,
    hasListingDestinationValues,
    hasFilledDates
} from './';

function getSearchValues(latestDestinationValues, latestDatesValues, latestGuestsValues) {
    return {
        ...latestDestinationValues,
        ...latestDatesValues,
        ...latestGuestsValues
    };
}

function getSearchFilters(latestSearchValues, latestDestinationValues) {
    const {
        filters: searchFilters
    } = latestSearchValues;

    const destinationFilter = getDestinationValuesFilter(latestDestinationValues);

    const filters = [destinationFilter, ...searchFilters].map((filter) => (
        !isNaN(parseInt(filter, 10))
            ? `filter:${filter}`
            : undef
    ));

    return getUniqueArray(getNoUndefArray(filters));
}

function getListingSearchRequest(latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const searchValues = getSearchValues(latestDestinationValues, latestDatesValues, latestGuestsValues);

    const {
        listingProps: {
            listingUrl,
            unitId
        },
        startDate: arrival,
        endDate: departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchValues;

    return {
        listingUrl,
        unitId,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded
    };
}

// eslint-disable-next-line complexity
function getListingSearchPath(latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const searchRequest = getListingSearchRequest(latestDestinationValues, latestDatesValues, latestGuestsValues);

    const {
        listingUrl,
        unitId,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchRequest;

    const separator = unitId ? '&' : '?';

    const params = getUrlSearchParamsString({
        ...(
            hasFilledDates(arrival, departure)
                ? {arrival, departure}
                : {noDates: true}
        ),
        ...(adultsCount && {adultsCount}),
        ...(childrenCount && {childrenCount}),
        ...(petIncluded && {petIncluded})
    });

    return `${listingUrl}${separator}${params}`;
}

function getLocationSearchRequest(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const searchValues = getSearchValues(latestDestinationValues, latestDatesValues, latestGuestsValues);

    const {
        destination: q,
        startDate: arrival,
        endDate: departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchValues;

    const filter = getSearchFilters(latestSearchValues, latestDestinationValues);

    return {
        q,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded,
        filter
    };
}

function getLocationSearchPath(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const searchRequest = getLocationSearchRequest(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues);

    return toURL(searchRequest);
}

function getSearchPath(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    return (
        hasListingDestinationValues(latestDestinationValues)
            ? getListingSearchPath(latestDestinationValues, latestDatesValues, latestGuestsValues)
            : getLocationSearchPath(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues)
    );
}

function getSearchData(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const searchValues = getSearchValues(latestDestinationValues, latestDatesValues, latestGuestsValues);
    const searchPath = getSearchPath(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues);

    return {
        ...searchValues,
        searchPath
    };
}

export {
    getListingSearchPath,
    getListingSearchRequest,
    getLocationSearchPath,
    getLocationSearchRequest,
    getSearchData,
    getSearchFilters,
    getSearchPath,
    getSearchValues
};
